import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';
import { ROTARY_WORLDWIDE_VIDEO_EMBED_SRC } from '../data/rotaryWorldwideContent';

/**
 * Dünyada Rotary — URL: /rotary-worldwide
 */
export function RotaryWorldwidePage() {
    const { t } = useTranslation();

    const paragraphs = useMemo(() => {
        const raw = t('rotaryWorldwide.paragraphs', { returnObjects: true });
        return Array.isArray(raw) ? raw : [];
    }, [t]);

    return (
        <>
            <PageSeo
                title={`${t('rotaryWorldwide.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.rotaryWorldwide')}
            />
            <SubpageLayout
                title={t('rotaryWorldwide.title')}
                subtitle={t('rotaryWorldwide.subtitle')}
                contentClassName="rotary-worldwide-page"
            >
            <div className="rotary-worldwide-embed-wrap">
                <iframe
                    className="rotary-worldwide-embed"
                    src={ROTARY_WORLDWIDE_VIDEO_EMBED_SRC}
                    title={t('rotaryWorldwide.iframeTitle')}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    referrerPolicy="strict-origin-when-cross-origin"
                />
            </div>
            <div className="rotary-worldwide-prose">
                {paragraphs.map((text, i) => (
                    <p key={i} className="rotary-worldwide-prose-p mb-0">
                        {text}
                    </p>
                ))}
            </div>
        </SubpageLayout>
        </>
    );
}
